(function () {
  'use strict';

  var selector = '#shopify-pc__banner__body-policy-link';
  var ABSENT = 0;
  var PRESENT_NON_TARGET = 1;
  var REPAIRED = 2;
  // Shopify inserts the privacy banner asynchronously. Observe only during
  // startup so pages where the banner never appears do not retain a global observer.
  var STARTUP_OBSERVER_WINDOW_MS = 5000;
  var observer = null;
  var startupTimer = null;
  var readyListenerAttached = false;

  function inspectPolicyLink() {
    var link = document.querySelector(selector);
    if (!link) return ABSENT;

    var destination;
    try {
      destination = new URL(link.href, location.href);
    } catch (error) {
      return PRESENT_NON_TARGET;
    }
    if (!destination.pathname.endsWith('/policies/privacy-policy')) return PRESENT_NON_TARGET;

    link.href = new URL('/policies/privacy-policy', location.origin).href;
    return REPAIRED;
  }

  function teardown() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (startupTimer !== null) {
      clearTimeout(startupTimer);
      startupTimer = null;
    }
    if (readyListenerAttached) {
      document.removeEventListener('DOMContentLoaded', onReady);
      readyListenerAttached = false;
    }
  }

  function inspectAndSettle() {
    if (inspectPolicyLink() !== ABSENT) teardown();
  }

  function onReady() {
    readyListenerAttached = false;
    inspectAndSettle();
  }

  if (inspectPolicyLink() !== ABSENT) return;

  observer = new MutationObserver(inspectAndSettle);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  startupTimer = setTimeout(teardown, STARTUP_OBSERVER_WINDOW_MS);
  if (document.readyState === 'loading') {
    readyListenerAttached = true;
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  }
})();
